import React from 'react';
const BASE_ROWS = 4;
export function DeprecatedProductsCardsList({ dataHook, className, height, width, background, children, marketingItemsAmount = 0, }) {
    const numOfChildren = React.Children.count(children);
    const numOfColumns = Math.floor(numOfChildren / 2);
    const numberOfRows = BASE_ROWS + marketingItemsAmount;
    const style = {
        display: 'grid',
        height: height ?? 'inherit',
        width: width ?? '100%',
        background: background ?? 'transparent',
        border: '1px solid #DFE5EB',
        gridAutoFlow: 'column',
        gridTemplateColumns: `repeat(${numOfColumns}, 1fr 0px) 1fr`,
        gridTemplateRows: `repeat(${numberOfRows}, min-content)`,
    };
    return (React.createElement("div", { className: className, style: style, "data-hook": dataHook }, children));
}
//# sourceMappingURL=DeprecatedProductsCardsList.js.map